import { Injectable } from '@angular/core';
import { ModalService } from '../../core/modal/modal.service';
import { SupplementComponent } from './supplement/supplement.component';
import { QrcodePaymentMethodComponent } from './qrcode-payment-method/qrcode-payment-method.component';
import { ModalSettings } from '../../core/modal/modal.model';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { IInvoice } from '../../core/models/organisation.model';
import { QrcodeConfig } from './payment-method/payment-method.type';

@Injectable({
  providedIn: 'root',
})

export class PaymentAccountModalService {
  private readonly settingQrcodeModal: ModalSettings = {
    backgroundColor: '#ffffff',
  };

  constructor(private modalService: ModalService) {}

  openSupplementModal(billingAccountNumber: string): void {
    this.modalService.close();
    this.modalService.openOld(SupplementComponent, {
      billingAccountNumber,
    });
  }

  openQrcodeModal(
    billingAccountNumber: string,
    qrcode?: QrcodeConfig['qrCodeStartData'],
    paymentMethodName?: QrcodeConfig['name'],
  ): void {
    this.modalService.close();
    this.modalService.openOld(
      QrcodePaymentMethodComponent,
      {
        billingAccountNumber,
        qrcode,
        paymentMethodName,
      },
      this.settingQrcodeModal,
    );
  }

  openPaymentMethodModal(billingAccountNumber: string): void {
    this.modalService.close();
    this.modalService.openOld(PaymentMethodComponent, {
      billingAccountNumber,
    });
  }

  openInvoiceModal(invoice: IInvoice): void {
    this.modalService.openOld(InvoiceComponent, {
      invoice,
    });
  }
}
